<template>
  <div class="home container">

    <div class="row mx-auto my-4 mv_store_info">


      <div class="left" style="flex:1">
        <h4>Info sul locale</h4>
        <div>
          <p>{{ $store.state.shopInfo.description }}</p>
          <ul class="mv_services_list">
            <li><a :href="'tel:' + $store.state.shopInfo.telephoneNumber"><font-awesome-icon icon="mobile" />
                {{ $store.state.shopInfo.telephoneNumber }}</a></li>
            <li><font-awesome-icon icon="location-arrow" /> {{ $store.state.shopInfo.address }}</li>
            <li><font-awesome-icon icon="clock" /> {{ $store.state.shopInfo.openingHours }}</li>

          </ul>
          <!--<a href="#" class="btn btn-lg btn-primary my-2" id="mv_book_btn" @click="book">Prenota ora un tavolo</a>-->
          <div class="buttons d-flex  justify-content-around">
            <a class="btn btn-lg btn-primary d-flex align-items-center mx-1" target="_blank" v-if="$store.state.shopInfo.socialLinks && $store.state.shopInfo.socialLinks.facebook"
              :href="$store.state.shopInfo.socialLinks.facebook">
              <svg xmlns="http://www.w3.org/2000/svg" style="width: 24px;height: 24px;margin-right: 0.5em;fill: #FFF;"
                viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                <path
                  d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" />
              </svg>
              Facebook</a>
            <a class="btn btn-lg btn-primary d-flex align-items-center mx-1" target="_blank" v-if="$store.state.shopInfo.socialLinks && $store.state.shopInfo.socialLinks.instagram"
              :href="$store.state.shopInfo.socialLinks.instagram">
              <svg xmlns="http://www.w3.org/2000/svg" style="width: 24px;height: 24px;margin-right: 0.5em;fill: #FFF;"
                viewBox="0 0 448 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                <path
                  d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
              </svg>
              Instagram</a>
            <!--<a class="btn btn-lg btn-primary">Whatsapp</a>-->
          </div>
        </div>
      </div>
      <div class="right" v-if="$store.state.storeGallery.filter(x => !x.primary).length > 0" style="flex:1">
        <div class="mv_store_gallery_pw">
          <div id="mv_store_gallery_text">
            <h2>Galleria</h2>
          </div>
          <img :src="'./api/Image/Get/' + (selectedImage || primaryImage)" v-if="selectedImage || primaryImage">
        </div>
        <div class="row mx-auto mv_store_gallery_thumbnails">
          <carousel :loop="true" :navigationEnabled="false" :paginationEnabled="false" :perPage="3" class="img_carousel"
            v-if="$store.state.storeGallery">
            <slide v-for="img in $store.state.storeGallery.filter(x => !x.primary)" :key="img.id">
              <div class="mv_gallery_thumb" :class="{ selected: selectedImage == img.id }"
                @click="selectedImage = img.id">
                <img :src="'./api/Image/Get/' + img.id">
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
    <div class="mv_store_menu">
      <h4>Il Menu</h4>
      <br>
      <div class="mv_categories_container">
        <HomeCategory v-for="(cat, i) in $store.getters.categories" :key="'c_' + i" :cat="cat" />
      </div>
    </div>
    <div class="mv_store_menu"
      v-if="$store.state.documents && $store.state.documents.length && $store.state.documents.length > 0">
      <h4>Altre Informazioni</h4>
      <br>
      <div class="mv_categories_container">
        <Document v-for="(doc, i) in $store.state.documents" :key="'d_' + i" :document="doc" />
      </div>
    </div>
  </div>
</template>

<script>
import HomeCategory from '@/components/HomeCategory.vue';
import Document from '@/components/Document.vue';
import NewReservationVue from './reservations/NewReservation.vue';
import { Carousel, Slide } from 'vue-carousel';

export default {
  data() {
    return {
      color: '#DDDDDD',
      selectedImage: null,
      images: [
        '/gallery_placeholder.jpg',
        '/hero_placeholder.jpg',
        '/l.jpg'
      ]
    }
  },
  components: {
    HomeCategory,
    Carousel,
    Slide,
    Document
  },
  computed: {
    primaryImage() {
      return this.$store.state.storeGallery && this.$store.state.storeGallery.filter(x => !x.primary).length > 0 ? this.$store.state.storeGallery.filter(x => !x.primary)[0].id : ''
    }
  },
  async created() {
    if (this.$route.params.tableId) {
      await this.$store.dispatch("setTable", this.$route.params.tableId);
      this.$router.replace("/");
    }

  },
  methods: {
    book() {
      this.$root.$emit('popup', { component: NewReservationVue })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.mv_store_info {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media screen and (max-width:1000px) {
    flex-direction: column-reverse
  }

  .left {
    margin-right: 2em;
  }

  .mv_store_gallery_pw {
    border-radius: $radius;
    height: 250px;
    position: relative;
    overflow: hidden;

    // cursor: pointer;
    #mv_store_gallery_text {
      position: absolute;
      color: white;
      background-color: rgba(0, 0, 0, .8);
      bottom: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      box-sizing: border-box;
      padding: 0 1em;

      transition: transform .3s;
      transform: translateY(100%);
    }

    /*:nth-last-child()
      &:hover {
        img {
          transform: scale(1.1);
        }
        #mv_store_gallery_text {
          transform: translateY(0);
        }
      } */
    img {
      z-index: 0;
      height: 250px;
      width: 100%;
      transition: .5s;
      object-fit: cover;
    }
  }

  #mv_book_btn {
    width: 100%;
  }
}

.mv_services_list {
  list-style-type: none;
  box-sizing: border-box;
  padding: 0;
  margin-bottom: 2em;

  li {
    margin: 1.5em 0;

    .svg-inline--fa {
      margin-right: 1em;
    }
  }
}


// Categories
.mv_categories_container {
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: .5em;

  @media screen and (max-width: 1050px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  &:hover {
    @media screen and (min-width: 769px) {
      .mv_category:not(:hover) {
        opacity: 0.5;
      }
    }
  }
}

.mv_store_gallery_thumbnails {
  margin-top: .5em;

}

.mv_gallery_thumb {
  border-radius: $radius;
  cursor: pointer;
  margin: .5em;
  height: 100px;
  // width: 100px;
  opacity: .5;

  &:hover,
  &.selected {
    opacity: 1;
  }

  overflow: hidden;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}


.mv_store_info,
.mv_store_menu {
  padding: 1em;
  box-sizing: border-box;
}
</style>

<style lang="scss">
.VueCarousel-pagination {
  position: absolute;
  bottom: .5em;
}

.VueCarousel-inner {
  flex-basis: 120px !important
}
</style>